import React from "react"
import { Link } from 'gatsby'
import Layout from "../components/layout"
import { HeadingTwo, Paragraph } from '../elements'
import { linkAccent } from '../variables'
import SEO from "../components/seo"
import styled from 'styled-components'

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <NotFound>
      <HeadingTwo fontSize="36px">404 – not found</HeadingTwo>
      <Paragraph margin="41px 0 0 0" fontSize="27px" textAlign="center">We’re sorry, that page no longer exists…<br />
Try reading <Link to="/facts-and-figures">Frequently Asked Questions</Link> or return to the <Link to="/">homepage</Link>.</Paragraph>
    </NotFound>
  </Layout>
)

export default NotFoundPage


const NotFound = styled.section`
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Paragraph}{
    max-width: 823px;
    line-height: 1.48;

    a{
      font-weight: 700;
      color: ${linkAccent};
    }
  }
`;